// import Cookies from 'js-cookie'
// The account last chosen in this browser: picked again after a reload, once its signature has
// expired or on the next sign-in, instead of asking a person with several accounts every time.
export const LAST_ACCOUNT_ID_ATTR = 'laid'

// Left behind by the Cognito sign-in (before #294): tokens, user id, client id, known domains.
// Removed on start; Keycloak tokens are never stored.
const LEGACY_AUTH_KEYS = ['pd', 'pk', 'pc', 'pci', 'ld']

export function removeLegacyAuthData() {
  try {
    LEGACY_AUTH_KEYS.forEach(key => localStorage.removeItem(key))
  } catch {
    // storage unavailable: nothing to remove
  }
}

export const CACHE_KEY_PREFIX = 'cah-'

export function getItem(key) {
  const cache_key = CACHE_KEY_PREFIX + key
  const itemStr = localStorage.getItem(cache_key)
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null
  }
  const item = JSON.parse(itemStr)
  const now = new Date()
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(cache_key)
    return null
  }
  return item.value
}

export function setItem(key, value, ttl = 60 * 2) { // 120 seconds --> 2 minutes
  const now = new Date()

  const item = {
    value: value,
    expiry: now.getTime() + ttl * 1000
  }
  const cache_key = CACHE_KEY_PREFIX + key
  return localStorage.setItem(cache_key, JSON.stringify(item))
}

export function removeItem(key) {
  const cache_key = CACHE_KEY_PREFIX + key
  return localStorage.removeItem(cache_key)
}

export function clearStorage() {
  // Only an account id: on the next sign-in it is picked again if the person has it.
  const never_delete = [
    LAST_ACCOUNT_ID_ATTR
  ]
  const arr = [] // Array to hold the keys
  // Iterate over localStorage and insert the keys that meet the condition into arr
  for (let i = 0; i < localStorage.length; i++) {
    if (!never_delete.find(d => d === localStorage.key(i))) {
      arr.push(localStorage.key(i))
    }
  }
  // Iterate over arr and remove the items by key
  for (let j = 0; j < arr.length; j++) {
    localStorage.removeItem(arr[j])
  }
}

export function clearCachedItems() {
  const arr = [] // Array to hold the keys
  // Iterate over localStorage and insert the keys that meet the condition into arr
  for (let i = 0; i < localStorage.length; i++) {
    if (localStorage.key(i).substring(0, 3) === CACHE_KEY_PREFIX) {
      arr.push(localStorage.key(i))
    }
  }

  // Iterate over arr and remove the items by key
  for (let i = 0; i < arr.length; i++) {
    localStorage.removeItem(arr[i])
  }
}
